import * as React from 'react';
export const members1StSvg = React.forwardRef(function members1StSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#DA332D',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm25.096 23.877-.157-.065h-.074l-.157-.11a.795.795 0 0 1-.314-.657V7.195a.185.185 0 0 0-.194-.186h-2.692a.342.342 0 0 0-.314.185l-1.72 3.468a.074.074 0 0 0 0 .102h1.248a.453.453 0 0 1 .453.453v11.8a.814.814 0 0 1-.305.657l-.166.11h-.074l-.157.065v.546h4.707v-.546h-.046',
      fill: '#fff',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'm18.928 14.5-2.265 4.624-1.295 2.635-.795-1.415-.194-.323-2.09-3.542-2.239-3.782s-.055 0-.064.055V22.99a.832.832 0 0 0 .323.657c.13.1.277.176.435.222v.564H6.028v-.573l.25-.12c.091-.047.178-.103.258-.167a.509.509 0 0 0 .195-.453V8.21a.703.703 0 0 0-.222-.545A.925.925 0 0 0 6 7.444V7h4.254a.665.665 0 0 1 .601.38l2.626 4.503.24.398 2.6 4.448 1.941-3.95a.258.258 0 0 1 .204-.129h1.211a.083.083 0 0 1 .084.084m6.667-3.487a1.411 1.411 0 0 0-.194-.13l-.24-.101-.213-.065-.139-.083a.203.203 0 0 1-.083-.092.418.418 0 0 1 0-.148.25.25 0 0 1 .083-.195.322.322 0 0 1 .24-.083.416.416 0 0 1 .306.13.74.74 0 0 1 .176.351h.157v-.694h-.25v.102l-.175-.065a.925.925 0 0 0-.232 0 .601.601 0 0 0-.638.602.573.573 0 0 0 .194.444c.06.046.126.086.195.12l.203.083.203.074a.472.472 0 0 1 .148.083.287.287 0 0 1 .084.102c.014.048.014.1 0 .148a.323.323 0 0 1-.093.24.416.416 0 0 1-.268.093.388.388 0 0 1-.222-.065.684.684 0 0 1-.176-.148.989.989 0 0 1-.185-.38h-.157v.74h.194v-.12c.056.04.114.074.176.102a.74.74 0 0 0 .315.065.712.712 0 0 0 .527-.185.612.612 0 0 0 .194-.472.78.78 0 0 0 0-.25.787.787 0 0 0-.102-.203m1.554.713h-.269a.277.277 0 0 1-.148 0 .203.203 0 0 1-.083-.093.24.24 0 0 1 0-.139.823.823 0 0 1 0-.213v-1.11h.527v-.24h-.564v-.629h-.397v.63h-.343v.24h.333v1.36a.62.62 0 0 0 .13.406.397.397 0 0 0 .342.13.833.833 0 0 0 .259 0l.231-.093v-.185l-.018-.065Z',
      fill: '#fff',
    }),
  );
});
members1StSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var members1St = {
  category: 'brand',
  colorable: false,
  name: 'members1St',
  svg: members1StSvg,
};
